// extracted by mini-css-extract-plugin
module.exports = {"suggestionsList":"SuggestionsList_suggestionsList__3IBzx","suggestion":"SuggestionsList_suggestion__1SOZL","active":"SuggestionsList_active__2H7QX"};